export enum PassangerType {
  /** Nightjet Booking Internal */
  Adult = 'adult',
  Child = 'child',
  TenToFourteenYearOldChild = "child_10_to_14",
  SmallChild = 'small-child',
  SmallChildSeat = 'small-child-seat',

  /** Tickethsop */
  Person = 'person',
  Challenged = 'challenged',
  Wheelchair = 'wheelchair',
  Dog = 'dog',
  Bike = 'bike',
  Item = 'item',
  Motorbike = 'motorbike',
  Car = 'car',
};
